import { SearchOption } from '../../../data/searchStateData'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { setFilterSelectionActive, setFilterSelectionIndex } from '../../../redux/reducers/searchSlice'
import IconText from '../../iconText/IconText'
import './style.scss'

interface SubFilterButtonProps {
	searchFilter: SearchOption
	index: number
}

function SubFilterButton({searchFilter, index}: SubFilterButtonProps) {
	const subFilterSelectionActive = useAppSelector(state => state.search.subFilterSelectionActive)
	const subFilterSelectionIndex = useAppSelector(state => state.search.subFilterSelectionIndex)
	const subFilterValueCounter = useAppSelector(state => state.search.subFilterValueCounter)

	const dispatch = useAppDispatch()

	const buttonClickHandler = () => {
		if (subFilterSelectionIndex === index) {
			dispatch(setFilterSelectionActive(!subFilterSelectionActive))
		} else {
			dispatch(setFilterSelectionActive(true))
		}
		dispatch(setFilterSelectionIndex(index))
	}

	const getLabel = () => {
		if (searchFilter.value === undefined) {
			return searchFilter.label
		} else {
			if (typeof searchFilter.value === 'number') {
				return searchFilter.valueLabels[searchFilter.value]
			} else {
				let valueArr: number[] = searchFilter.value as number[]
				if (valueArr.length > 1) {
					return `${searchFilter.valueLabels[valueArr[0]]} - ${searchFilter.valueLabels[valueArr[1]]}`
				} else {
					return searchFilter.valueLabels[valueArr[0]]
				}
			}
		}
	}

	return (
		<button 
			className={`sub-filter-button ${subFilterSelectionActive && subFilterSelectionIndex === index ? 'active' : ''}`}
			onClick={() => { buttonClickHandler() }}
		>
			<div className='sub-filter-button-icon'>
				<img
					src={`/imgs/icons/icon-${searchFilter.label.toLowerCase()}.svg`}
					alt={`${searchFilter.label.toLowerCase()} icon`}
				/>
			</div>
			{subFilterValueCounter && <div className='sub-filter-button-value'><IconText text={getLabel()} /></div>}
		</button>
	)
}

export default SubFilterButton
